import { Swiper, Navigation } from 'swiper';
import 'swiper/swiper.scss';

document.addEventListener('DOMContentLoaded', ()=> {
    
    const cards = document.querySelector('.js-cardsSwiper'),
          videos = document.querySelector('.js-videos');

    const cardsCarousel = ()=> {
        let mobile = false, swiper;

	    swiper = new Swiper(cards, {
    	    modules: [Navigation],
            breakpoints: {
                520: {
                    spaceBetween: 24,
                },
                1025: {
                    slidesOffsetAfter: 0,
                    slidesOffsetBefore: 0,
                    spaceBetween: 48,
                }
            },
            navigation: {
                nextEl: '.js-cards .swiper-button-next',
                prevEl: '.js-cards .swiper-button-prev',
            },
            slidesOffsetAfter: 18,
            slidesOffsetBefore: 18,
            slidesPerView: 'auto',
            spaceBetween: 12,
            speed: 500
        });
    };
    
    const videosCarousel = ()=> {
        const nav = document.querySelector('.c-videos__nav'),
              slides = videos.querySelectorAll('.swiper-slide');

	    const swiper = new Swiper(videos, {
    	    modules: [Navigation],
            breakpoints: {
                1025: {
                }
            },
            navigation: {
                nextEl: '.c-videos .swiper-button-next',
                prevEl: '.c-videos .swiper-button-prev',
            },
            slidesPerView: 'auto',
            speed: 500
        });
        
        let mediaQuery = '(max-width: 1024px)',
            mediaQueryList = window.matchMedia(mediaQuery);
            
        if (slides.length <= 3) {
            nav.style.display = 'none'
            
            mediaQueryList.matches ? nav.removeAttribute('style') : false;
        }
        
        mediaQueryList.addEventListener('change', event => {
            event.matches ? nav.removeAttribute('style') : nav.style.display = 'none';
        })
    };
  
    window.carousels = function() {
        cards ? cardsCarousel() : false;
        videos ? videosCarousel() : false;
    };

}, false)
